<template>
  <div class="form-group">
    <label v-if="title">{{title}}</label>
    <div class="input-group input-group-sm">
      <input
        type="text"
        :id="elementId"
        :value="value"
        class="form-control"
        readonly>
      <div class="input-group-prepend input-copy"
        :class="{'input-copied': isCopied}"
        @click.stop="copyMessage(elementId)">
        <span class="input-group-text">
          {{ isCopied ? $t('common:copied') : $t('common:copy') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    elementId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isCopied: false,
    };
  },
  methods: {
    copyMessage(copyMessageKey) {
      this.isCopied = true;

      const copyText = document.getElementById(copyMessageKey);
      copyText.focus();
      copyText.select();

      try {
        document.execCommand('copy');
        setTimeout(() => {
          this.isCopied = false;
        }, 1000);
      } catch (err) {
        setTimeout(() => {
          this.isCopied = false;
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

label {
  margin-bottom: $spacer * 0.25;
  color: #FFF;
}

input[readonly] {
  background: #29292d;
  border-color: $gray-700;
  color: $gray-200;
}

.help-text {
  margin-top: $spacer * 0.5;
  display: flex;
  justify-content: flex-start;
  margin-left: auto;
  p {
    margin-bottom: 0;
  }
}

.input-copy {
  cursor: pointer;
  border-color: $gray-700;
  border-radius: 0 0.25rem 0.25rem 0;
  .input-group-text {
    background-color: #FFF;
    border-radius: 0 0.25rem 0.25rem 0;
  }
  &.input-copied {
    .input-group-text {
      background-color: $gray-400;
    }
  }
}

</style>
